import randomNumberForToday from '../../../../common/utils/randomNumberForToday'

const data: any = [
  {
    id: 2833226,
    name: 'Avada | Website Builder For WordPress & WooCommerce',
    site: 'themeforest.net',
    classification: 'wordpress/corporate',
    price_cents: 6000,
    number_of_sales: 1571,
    author_username: 'ThemeFusion',
    author_url: 'https://themeforest.net/user/ThemeFusion',
    url:
      'https://themeforest.net/item/avada-responsive-multipurpose-theme/2833226',
    rating: {
      rating: 4.77,
      count: 23209
    },
    updated_at: '2020-05-09T01:39:59+10:00',
    trending: false,
    previews: {
      icon_with_landscape_preview: {
        icon_url:
          'https://previews.customer.envatousercontent.com/files/288735716/Thumbnail.jpg',
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/288735720/screenshots/00-Preview.__large_preview.jpg'
      },
      live_site: {
        url:
          'https://themeforest.net/item/avada-responsive-multipurpose-theme/full_screen_preview/2833226'
      },
      landscape_preview: {
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/288735720/screenshots/00-Preview.__large_preview.jpg',
        image_urls: [
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/288735720/screenshots/00-Preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=21d8b50bb15af85741988606cb4cb95e',
            width: 590,
            height: 300
          }
        ]
      }
    },
    attributes: [
      {
        name: 'columns',
        value: '4+'
      },
      {
        name: 'compatible-browsers',
        value: ['IE11', 'Firefox', 'Safari', 'Opera', 'Chrome', 'Edge']
      },
      {
        name: 'compatible-software',
        value: [
          'WordPress 5.3.x',
          'WordPress 5.2.x',
          'WordPress 5.1.x',
          'WordPress 5.0.x',
          'WordPress 4.9.x',
          'WordPress 4.8.x'
        ]
      },
      {
        name: 'compatible-with',
        value: [
          'bbPress 2.5.x',
          'BuddyPress 5.0.x',
          'Easy Digital Downloads',
          'Events Calendar',
          'Events Calendar Pro',
          'Gravity Forms',
          'WooCommerce 4.0.x',
          'WP e-Commerce 3.10.x',
          'WPML'
        ]
      },
      {
        name: 'demo-url',
        value: 'http://demo.theme-fusion.com'
      },
      {
        name: 'documentation',
        value: 'Well Documented'
      },
      {
        name: 'framework',
        value: null
      },
      {
        name: 'gutenberg-optimized',
        value: 'Yes'
      },
      {
        name: 'high-resolution',
        value: 'Yes'
      },
      {
        name: 'layout',
        value: 'Responsive'
      },
      {
        name: 'themeforest-files-included',
        value: ['Layered PSD', 'PHP Files', 'CSS Files', 'JS Files']
      },
      {
        name: 'widget-ready',
        value: 'Yes'
      }
    ],
    key_features: [
      '#1 Selling Theme',
      'Best Customer Support',
      'Free updates packed with new features'
    ],
    image_urls: [],
    tags: [
      'blog',
      'business',
      'clean',
      'corporate',
      'creative',
      'ecommerce',
      'gallery',
      'multipurpose',
      'one page',
      'photography',
      'portfolio',
      'responsive',
      'shop',
      'woocommerce',
      'wordpress'
    ],
    ui: {
      isInBookmarks: false,
      isInFavourites: false
    }
  },
  {
    id: 5556590,
    name: 'The7 — Multi-Purpose Website Building Toolkit for WordPress',
    site: 'themeforest.net',
    classification: 'wordpress/corporate',
    price_cents: 3900,
    number_of_sales: 1026,
    author_username: 'Dream-Theme',
    author_url: 'https://themeforest.net/user/Dream-Theme',
    url:
      'https://themeforest.net/item/the7-responsive-multipurpose-wordpress-theme/5556590',
    rating: {
      rating: 4.75,
      count: 7539
    },
    updated_at: '2020-04-30T20:57:44+10:00',
    trending: false,
    previews: {
      icon_with_landscape_preview: {
        icon_url:
          'https://previews.customer.envatousercontent.com/files/237739549/thumbnail_v.6.0.0.png',
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/270413780/the7-preview.__large_preview.png'
      },
      live_site: {
        url:
          'https://themeforest.net/item/the7-responsive-multipurpose-wordpress-theme/full_screen_preview/5556590'
      },
      landscape_preview: {
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/270413780/the7-preview.__large_preview.png',
        image_urls: [
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/270413780/the7-preview.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=f4604146e9077f2f2a2afde4a0a3ae12',
            width: 590,
            height: 300
          }
        ]
      }
    },
    attributes: [
      {
        name: 'columns',
        value: '4+'
      },
      {
        name: 'compatible-browsers',
        value: ['IE11', 'Firefox', 'Safari', 'Opera', 'Chrome', 'Edge']
      },
      {
        name: 'compatible-software',
        value: ['WordPress 5.4.x', 'WordPress 5.3.x']
      },
      {
        name: 'compatible-with',
        value: [
          'bbPress 2.5.x',
          'Easy Digital Downloads',
          'Easy Digital Downloads 2.9.x',
          'Elementor',
          'Events Calendar',
          'Events Calendar Pro',
          'Events Calendar Pro 3.x',
          'Gravity Forms',
          'Gravity Forms 1.9.x',
          'WooCommerce 4.0.x',
          'WP EasyCart',
          'WPBakery Page Builder 6.1.x',
          'WPML'
        ]
      },
      {
        name: 'demo-url',
        value: 'https://the7.io/'
      },
      {
        name: 'documentation',
        value: 'Well Documented'
      },
      {
        name: 'framework',
        value: null
      },
      {
        name: 'gutenberg-optimized',
        value: 'Yes'
      },
      {
        name: 'high-resolution',
        value: 'Yes'
      },
      {
        name: 'layout',
        value: 'Responsive'
      },
      {
        name: 'themeforest-files-included',
        value: ['Layered PSD', 'PHP Files', 'CSS Files', 'JS Files', 'PSD']
      },
      {
        name: 'widget-ready',
        value: 'Yes'
      }
    ],
    key_features: [
      'The Most Customizable Theme on the Market',
      '6 Premium Plugins + Tons of Premium Content',
      '$39! Complete Toolkit at Incredible Price!'
    ],
    image_urls: [],
    tags: [
      'business',
      'corporate',
      'creative',
      'custom layout',
      'customizable',
      'fluid',
      'gutenberg',
      'ios',
      'mobile',
      'photography',
      'portfolio',
      'seo',
      'ultimate addons',
      'woocommerce',
      'wpbakery page builder'
    ],
    ui: {
      isInBookmarks: false,
      isInFavourites: false
    }
  },
  {
    id: 5484319,
    name: 'Flatsome | Multi-Purpose Responsive WooCommerce Theme',
    site: 'themeforest.net',
    classification: 'wordpress/ecommerce/woocommerce',
    price_cents: 5900,
    number_of_sales: 781,
    author_username: 'UX-themes',
    author_url: 'https://themeforest.net/user/UX-themes',
    url:
      'https://themeforest.net/item/flatsome-multipurpose-responsive-woocommerce-theme/5484319',
    rating: {
      rating: 4.8,
      count: 5615
    },
    updated_at: '2020-04-26T07:29:07+10:00',
    trending: false,
    previews: {
      icon_with_landscape_preview: {
        icon_url:
          'https://previews.customer.envatousercontent.com/files/257130695/flatsome.png',
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/277736748/themeforest-poster.__large_preview.png'
      },
      live_site: {
        url:
          'https://themeforest.net/item/flatsome-multipurpose-responsive-woocommerce-theme/full_screen_preview/5484319'
      },
      landscape_preview: {
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/277736748/themeforest-poster.__large_preview.png',
        image_urls: [
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/277736748/themeforest-poster.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=944cb251ad7399bde1f96597abb7d32d',
            width: 590,
            height: 300
          }
        ]
      }
    },
    attributes: [
      {
        name: 'columns',
        value: '4+'
      },
      {
        name: 'compatible-browsers',
        value: [
          'IE9',
          'IE10',
          'IE11',
          'Firefox',
          'Safari',
          'Opera',
          'Chrome',
          'Edge'
        ]
      },
      {
        name: 'compatible-software',
        value: [
          'WordPress 5.4.x',
          'WordPress 5.3.x',
          'WordPress 5.2.x',
          'WordPress 5.1.x',
          'WordPress 5.0.x',
          'WordPress 4.9.x'
        ]
      },
      {
        name: 'compatible-with',
        value: [
          'WooCommerce 4.0.x',
          'WooCommerce 3.9.x',
          'WooCommerce 3.8.x',
          'WooCommerce 3.7.x',
          'WooCommerce 3.6.x',
          'WooCommerce 3.5.x',
          'WooCommerce 3.4.x',
          'WooCommerce 3.3.x',
          'WPML'
        ]
      },
      {
        name: 'demo-url',
        value: 'https://flatsome3.uxthemes.com'
      },
      {
        name: 'documentation',
        value: 'Well Documented'
      },
      {
        name: 'framework',
        value: null
      },
      {
        name: 'gutenberg-optimized',
        value: 'Yes'
      },
      {
        name: 'high-resolution',
        value: 'Yes'
      },
      {
        name: 'layout',
        value: 'Responsive'
      },
      {
        name: 'themeforest-files-included',
        value: ['Layered PSD', 'PHP Files', 'CSS Files', 'JS Files']
      },
      {
        name: 'widget-ready',
        value: 'Yes'
      }
    ],
    key_features: [
      'The #1 Best Selling WooCommerce Theme',
      'A super fast and mobile optimized theme',
      '3000+ 5-star ratings from happy customers'
    ],
    image_urls: [],
    tags: [
      'builder',
      'business',
      'colorful',
      'ecommerce',
      'flat',
      'mobile',
      'modern',
      'responsive',
      'retina',
      'shop',
      'sticky header',
      'touch sliders',
      'woocommerce'
    ],
    ui: {
      isInBookmarks: false,
      isInFavourites: false
    }
  },
  {
    id: 7758048,
    name: 'BeTheme - Responsive Multi-Purpose WordPress Theme',
    site: 'themeforest.net',
    classification: 'wordpress/corporate/business',
    price_cents: 5900,
    number_of_sales: 691,
    author_username: 'muffingroup',
    author_url: 'https://themeforest.net/user/muffingroup',
    url:
      'https://themeforest.net/item/betheme-responsive-multipurpose-wordpress-theme/7758048',
    rating: {
      rating: 4.82,
      count: 5914
    },
    updated_at: '2020-05-18T23:49:38+10:00',
    trending: false,
    previews: {
      icon_with_landscape_preview: {
        icon_url:
          'https://previews.customer.envatousercontent.com/files/289841366/betheme-small-preview.png',
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/289841371/01_betheme.__large_preview.png'
      },
      live_site: {
        url:
          'https://themeforest.net/item/betheme-responsive-multipurpose-wordpress-theme/full_screen_preview/7758048'
      },
      landscape_preview: {
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/289841371/01_betheme.__large_preview.png',
        image_urls: [
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/289841371/01_betheme.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=893ee1a7a45713546473f2e5fc476cd3',
            width: 590,
            height: 300
          }
        ]
      }
    },
    attributes: [
      {
        name: 'columns',
        value: '4+'
      },
      {
        name: 'compatible-browsers',
        value: ['IE11', 'Firefox', 'Safari', 'Opera', 'Chrome', 'Edge']
      },
      {
        name: 'compatible-software',
        value: [
          'WordPress 5.4.x',
          'WordPress 5.3.x',
          'WordPress 5.2.x',
          'WordPress 5.1.x',
          'WordPress 5.0.x'
        ]
      },
      {
        name: 'compatible-with',
        value: [
          'bbPress 2.5.x',
          'BuddyPress 4.1.x',
          'Easy Digital Downloads',
          'Elementor',
          'Events Calendar',
          'Gravity Forms',
          'Visual Composer 5.1.x',
          'WooCommerce 4.0.x',
          'WooCommerce 3.9.x',
          'WooCommerce 3.8.x',
          'WooCommerce 3.7.x',
          'WooCommerce 3.6.x',
          'WooCommerce 3.5.x',
          'WPBakery Page Builder 6.1.x',
          'WPBakery Page Builder 6.0.x',
          'WPBakery Page Builder 5.7.x',
          'WPML'
        ]
      },
      {
        name: 'demo-url',
        value: 'https://themes.muffingroup.com/be/splash/?die=1'
      },
      {
        name: 'documentation',
        value: 'Well Documented'
      },
      {
        name: 'framework',
        value: null
      },
      {
        name: 'gutenberg-optimized',
        value: null
      },
      {
        name: 'high-resolution',
        value: 'Yes'
      },
      {
        name: 'layout',
        value: 'Responsive'
      },
      {
        name: 'themeforest-files-included',
        value: ['PHP Files', 'CSS Files', 'JS Files']
      },
      {
        name: 'widget-ready',
        value: 'Yes'
      }
    ],
    key_features: [
      'Over 500 ready to use pre-built websites',
      'Easy 1-click updates of theme and plugins',
      'Instant and always up to date updates'
    ],
    image_urls: [],
    tags: [
      'boxed',
      'business',
      'content builder',
      'corporate',
      'creative',
      'full width',
      'mega menu',
      'multi-purpose',
      'multilingual',
      'theme options',
      'visual composer',
      'woocommerce',
      'wordpress',
      'wpml'
    ],
    ui: {
      isInBookmarks: false,
      isInFavourites: false
    }
  },
  {
    id: 7315054,
    name: 'Bridge - Creative Multipurpose WordPress Theme',
    site: 'themeforest.net',
    classification: 'wordpress/creative',
    price_cents: 5900,
    number_of_sales: 550,
    author_username: 'QODE',
    author_url: 'https://themeforest.net/user/QODE',
    url:
      'https://themeforest.net/item/bridge-creative-multipurpose-wordpress-theme/7315054',
    rating: {
      rating: 4.78,
      count: 6058
    },
    updated_at: '2020-05-23T01:10:59+10:00',
    trending: false,
    previews: {
      icon_with_landscape_preview: {
        icon_url:
          'https://previews.customer.envatousercontent.com/files/276761043/icon.png',
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/287444143/01_bridge.__large_preview.png'
      },
      live_site: {
        url:
          'https://themeforest.net/item/bridge-creative-multipurpose-wordpress-theme/full_screen_preview/7315054'
      },
      landscape_preview: {
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/287444143/01_bridge.__large_preview.png',
        image_urls: [
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/287444143/01_bridge.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=86058c93a2cdd5971c2a7e69c1f13fbc',
            width: 590,
            height: 300
          }
        ]
      }
    },
    attributes: [
      {
        name: 'columns',
        value: '4+'
      },
      {
        name: 'compatible-browsers',
        value: ['IE10', 'IE11', 'Firefox', 'Safari', 'Opera', 'Chrome', 'Edge']
      },
      {
        name: 'compatible-software',
        value: [
          'WordPress 5.4.x',
          'WordPress 5.3.x',
          'WordPress 5.2.x',
          'WordPress 5.1.x',
          'WordPress 5.0.x',
          'WordPress 4.9.x',
          'WordPress 4.8.x',
          'WordPress 4.7.x',
          'WordPress 4.6.1',
          'WordPress 4.6',
          'WordPress 4.5.x',
          'WordPress 4.5.2',
          'WordPress 4.5.1',
          'WordPress 4.5'
        ]
      },
      {
        name: 'compatible-with',
        value: [
          'Elementor',
          'Visual Composer 5.1.x',
          'WooCommerce 3.8.x',
          'WooCommerce 3.7.x',
          'WooCommerce 3.6.x',
          'WooCommerce 3.5.x',
          'WooCommerce 3.4.x',
          'WooCommerce 3.3.x',
          'WooCommerce 3.2.x',
          'WooCommerce 3.1.x',
          'WooCommerce 3.0.x',
          'WPBakery Page Builder 6.1.x',
          'WPBakery Page Builder 6.0.x',
          'WPML'
        ]
      },
      {
        name: 'demo-url',
        value: 'https://bridgelanding.qodeinteractive.com/'
      },
      {
        name: 'documentation',
        value: 'Well Documented'
      },
      {
        name: 'framework',
        value: null
      },
      {
        name: 'gutenberg-optimized',
        value: 'Yes'
      },
      {
        name: 'high-resolution',
        value: 'Yes'
      },
      {
        name: 'layout',
        value: 'Responsive'
      },
      {
        name: 'themeforest-files-included',
        value: ['PHP Files', 'CSS Files', 'JS Files']
      },
      {
        name: 'widget-ready',
        value: 'Yes'
      }
    ],
    key_features: [
      'A set of 480+ beautiful multipurpose demos',
      'Trusted by more than 130 000 customers',
      'Both WPBakery and Elementor compatible'
    ],
    image_urls: [],
    tags: [
      'agency',
      'blog',
      'business',
      'corporate',
      'creative',
      'creative agency',
      'design agency',
      'ecommerce',
      'elementor',
      'listing',
      'multipurpose',
      'one page',
      'photography',
      'portfolio',
      'woocommerce'
    ],
    ui: {
      isInBookmarks: false,
      isInFavourites: false
    }
  },
  {
    id: 13373220,
    name: 'Uncode - Creative Multiuse WordPress Theme',
    site: 'themeforest.net',
    classification: 'wordpress/creative',
    price_cents: 5900,
    number_of_sales: 406,
    author_username: 'undsgn',
    author_url: 'https://themeforest.net/user/undsgn',
    url:
      'https://themeforest.net/item/uncode-creative-multiuse-wordpress-theme/13373220',
    rating: {
      rating: 4.88,
      count: 2709
    },
    updated_at: '2020-04-01T01:15:21+11:00',
    trending: false,
    previews: {
      icon_with_landscape_preview: {
        icon_url:
          'https://previews.customer.envatousercontent.com/files/240190951/thumb.png',
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/273402999/uncode.__large_preview.png'
      },
      live_site: {
        url:
          'https://themeforest.net/item/uncode-creative-multiuse-wordpress-theme/full_screen_preview/13373220'
      },
      landscape_preview: {
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/273402999/uncode.__large_preview.png',
        image_urls: [
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/273402999/uncode.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=67c9914d466bed073f509bf694bc3613',
            width: 590,
            height: 300
          }
        ]
      }
    },
    attributes: [
      {
        name: 'columns',
        value: null
      },
      {
        name: 'compatible-browsers',
        value: [
          'IE9',
          'IE10',
          'IE11',
          'Firefox',
          'Safari',
          'Opera',
          'Chrome',
          'Edge'
        ]
      },
      {
        name: 'compatible-software',
        value: [
          'WordPress 5.4.x',
          'WordPress 5.3.x',
          'WordPress 5.2.x',
          'WordPress 5.1.x',
          'WordPress 5.0.x',
          'WordPress 4.9.x',
          'WordPress 4.8.x',
          'WordPress 4.7.x',
          'WordPress 4.6.1',
          'WordPress 4.6',
          'WordPress 4.5.x',
          'WordPress 4.5.2',
          'WordPress 4.5.1',
          'WordPress 4.5',
          'WordPress 4.4.2',
          'WordPress 4.4.1',
          'WordPress 4.4',
          'WordPress 4.3.1',
          'WordPress 4.3'
        ]
      },
      {
        name: 'compatible-with',
        value: [
          'WooCommerce 4.0.x',
          'WooCommerce 3.9.x',
          'WooCommerce 3.8.x',
          'WooCommerce 3.7.x',
          'WooCommerce 3.6.x',
          'WooCommerce 3.5.x',
          'WooCommerce 3.4.x',
          'WooCommerce 3.3.x',
          'WooCommerce 3.2.x',
          'WooCommerce 3.1.x',
          'WooCommerce 3.0.x',
          'WooCommerce 2.6.x',
          'WooCommerce 2.5',
          'WooCommerce 2.4.x'
        ]
      },
      {
        name: 'demo-url',
        value: 'https://undsgn.com/uncode/'
      },
      {
        name: 'documentation',
        value: 'Well Documented'
      },
      {
        name: 'framework',
        value: null
      },
      {
        name: 'gutenberg-optimized',
        value: 'Yes'
      },
      {
        name: 'high-resolution',
        value: 'Yes'
      },
      {
        name: 'layout',
        value: 'Responsive'
      },
      {
        name: 'themeforest-files-included',
        value: ['PHP Files', 'CSS Files', 'JS Files']
      },
      {
        name: 'widget-ready',
        value: 'Yes'
      }
    ],
    key_features: [
      'One of the creative top-sellers themes ever',
      '65 concepts, 200+ pages and GDPR compliant',
      'Featured on the most popular web design blogs'
    ],
    image_urls: [],
    tags: [
      'agency',
      'blog',
      'corporate',
      'creative',
      'freelance',
      'grid',
      'isotope',
      'magazine',
      'masonry',
      'modern',
      'multi purpose',
      'one page',
      'parallax',
      'portfolio',
      'visual composer'
    ],
    ui: {
      isInBookmarks: false,
      isInFavourites: false
    }
  },
  {
    id: 5489609,
    name: 'Newspaper',
    site: 'themeforest.net',
    classification: 'wordpress/blog-magazine/news-editorial',
    price_cents: 5900,
    number_of_sales: 404,
    author_username: 'tagDiv',
    author_url: 'https://themeforest.net/user/tagDiv',
    url: 'https://themeforest.net/item/newspaper/5489609',
    rating: {
      rating: 4.82,
      count: 6434
    },
    updated_at: '2020-05-21T19:36:02+10:00',
    trending: false,
    previews: {
      icon_with_landscape_preview: {
        icon_url:
          'https://previews.customer.envatousercontent.com/files/274954338/thumbnail.png',
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/285178443/preview_images/1.__large_preview.png'
      },
      live_site: {
        url:
          'https://themeforest.net/item/newspaper/full_screen_preview/5489609'
      },
      landscape_preview: {
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/285178443/preview_images/1.__large_preview.png',
        image_urls: [
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/285178443/preview_images/1.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=7cd17dbd1b118bf46a160d5479fc9a5a',
            width: 590,
            height: 300
          }
        ]
      }
    },
    attributes: [
      {
        name: 'columns',
        value: '2'
      },
      {
        name: 'compatible-browsers',
        value: [
          'IE8',
          'IE9',
          'IE10',
          'IE11',
          'Firefox',
          'Safari',
          'Opera',
          'Chrome',
          'Edge'
        ]
      },
      {
        name: 'compatible-software',
        value: [
          'WordPress 5.4.x',
          'WordPress 5.3.x',
          'WordPress 5.2.x',
          'WordPress 5.1.x',
          'WordPress 5.0.x',
          'WordPress 4.9.x',
          'WordPress 4.8.x',
          'WordPress 4.7.x',
          'WordPress 4.6.1',
          'WordPress 4.6',
          'WordPress 4.5.x',
          'WordPress 4.5.2',
          'WordPress 4.5.1',
          'WordPress 4.5',
          'WordPress 4.4.2',
          'WordPress 4.4.1',
          'WordPress 4.4',
          'WordPress 4.3.1',
          'WordPress 4.3',
          'WordPress 4.2',
          'WordPress 4.1',
          'WordPress 4.0'
        ]
      },
      {
        name: 'compatible-with',
        value: [
          'Facebook',
          'bbPress 2.5.x',
          'bbPress 2.4.x',
          'bbPress 2.3.x',
          'BuddyPress 3.0.x',
          'BuddyPress 2.5.x',
          'BuddyPress 2.4.x',
          'BuddyPress 2.3.x',
          'BuddyPress 2.2.x',
          'Gravity Forms',
          'WooCommerce 4.0.x',
          'WooCommerce 3.9.x',
          'WooCommerce 3.8.x',
          'WooCommerce 3.7.x',
          'WooCommerce 3.6.x',
          'WooCommerce 3.5.x',
          'WooCommerce 3.4.x',
          'WooCommerce 3.3.x',
          'WPBakery Page Builder 6.1.x',
          'WPBakery Page Builder 5.5.x',
          'WPBakery Page Builder 5.4.x',
          'WPBakery Page Builder 5.3',
          'WPBakery Page Builder 5.2.x',
          'WPML'
        ]
      },
      {
        name: 'demo-url',
        value: 'https://demo.tagdiv.com/select_demo/select_demo_newspaper'
      },
      {
        name: 'documentation',
        value: 'Well Documented'
      },
      {
        name: 'framework',
        value: null
      },
      {
        name: 'gutenberg-optimized',
        value: 'Yes'
      },
      {
        name: 'high-resolution',
        value: 'Yes'
      },
      {
        name: 'layout',
        value: 'Responsive'
      },
      {
        name: 'themeforest-files-included',
        value: ['PHP Files', 'CSS Files', 'JS Files']
      },
      {
        name: 'widget-ready',
        value: null
      }
    ],
    key_features: [
      'The Best Selling News and Magazine Theme',
      'Fast and Features Packed Template For Blogs',
      'Optimized for Mobile + AMP + GDPR Compliant'
    ],
    image_urls: [],
    tags: [
      'amp',
      'article',
      'bestseller',
      'blog',
      'editorial',
      'fast and clean',
      'journal',
      'magazine',
      'minimal responsive',
      'news',
      'newspaper',
      'publishing',
      'rating',
      'review',
      'simple theme paper'
    ],
    ui: {
      isInBookmarks: false,
      isInFavourites: false
    }
  },
  {
    id: 9207399,
    name: 'Porto | Multipurpose & WooCommerce Theme',
    site: 'themeforest.net',
    classification: 'wordpress/ecommerce/woocommerce',
    price_cents: 5900,
    number_of_sales: 370,
    author_username: 'p-themes',
    author_url: 'https://themeforest.net/user/p-themes',
    url:
      'https://themeforest.net/item/porto-responsive-wordpress-ecommerce-theme/9207399',
    rating: {
      rating: 4.92,
      count: 2427
    },
    updated_at: '2020-05-13T19:00:24+10:00',
    trending: false,
    previews: {
      icon_with_landscape_preview: {
        icon_url:
          'https://previews.customer.envatousercontent.com/files/278119889/Thumb-WP.png',
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/287200379/Themeforest-Preview.__large_preview.png'
      },
      live_site: {
        url:
          'https://themeforest.net/item/porto-responsive-wordpress-ecommerce-theme/full_screen_preview/9207399'
      },
      landscape_preview: {
        landscape_url:
          'https://previews.customer.envatousercontent.com/files/287200379/Themeforest-Preview.__large_preview.png',
        image_urls: [
          {
            name: null,
            url:
              'https://themeforest.img.customer.envatousercontent.com/files/287200379/Themeforest-Preview.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=cf4fa4269f6796975cd49c9fdf7ab428',
            width: 590,
            height: 300
          }
        ]
      }
    },
    attributes: [
      {
        name: 'columns',
        value: '4+'
      },
      {
        name: 'compatible-browsers',
        value: [
          'IE9',
          'IE10',
          'IE11',
          'Firefox',
          'Safari',
          'Opera',
          'Chrome',
          'Edge'
        ]
      },
      {
        name: 'compatible-software',
        value: [
          'WordPress 5.4.x',
          'WordPress 5.3.x',
          'WordPress 5.2.x',
          'WordPress 5.1.x',
          'WordPress 5.0.x',
          'WordPress 4.9.x',
          'WordPress 4.8.x',
          'WordPress 4.7.x',
          'WordPress 4.6.1'
        ]
      },
      {
        name: 'compatible-with',
        value: [
          'BuddyPress 5.0.x',
          'BuddyPress 4.1.x',
          'BuddyPress 3.0.x',
          'Elementor',
          'Visual Composer 5.1.x',
          'WooCommerce 4.0.x',
          'WooCommerce 3.9.x',
          'WooCommerce 3.8.x',
          'WooCommerce 3.7.x',
          'WooCommerce 3.6.x',
          'WooCommerce 3.5.x',
          'WooCommerce 3.4.x',
          'WooCommerce 3.3.x',
          'WPBakery Page Builder 6.1.x',
          'WPBakery Page Builder 6.0.x',
          'WPBakery Page Builder 5.7.x',
          'WPBakery Page Builder 5.6.x',
          'WPBakery Page Builder 5.5.x',
          'WPBakery Page Builder 5.4.x',
          'WPML',
          'Bootstrap 4.x'
        ]
      },
      {
        name: 'demo-url',
        value: 'https://www.portotheme.com/wordpress/porto_landing/'
      },
      {
        name: 'documentation',
        value: 'Well Documented'
      },
      {
        name: 'framework',
        value: null
      },
      {
        name: 'gutenberg-optimized',
        value: 'Yes'
      },
      {
        name: 'high-resolution',
        value: 'Yes'
      },
      {
        name: 'layout',
        value: 'Responsive'
      },
      {
        name: 'themeforest-files-included',
        value: ['PHP Files', 'CSS Files', 'JS Files']
      },
      {
        name: 'widget-ready',
        value: 'Yes'
      }
    ],
    key_features: [
      '#1 super optimized for site performance',
      'highly mobile optimized',
      'multi purpose & 20 niche woocommerce demo'
    ],
    image_urls: [],
    tags: [
      'bootstrap 4',
      'business',
      'ecommerce',
      'fast woocommerce theme',
      'mobile responsive ready',
      'multipurpose',
      'portfolio',
      'responsive',
      'responsive woocommerce theme',
      'retina',
      'rtl',
      'shop',
      'woocommerce',
      'woocommerce theme',
      'wordpress woocommerce theme'
    ],
    ui: {
      isInBookmarks: false,
      isInFavourites: false
    }
  }
]

const NUM_ITEMS = 4

export default () => {
  const start = randomNumberForToday(0, data.length / NUM_ITEMS) * NUM_ITEMS
  const end = start + NUM_ITEMS
  return {
    data: data.slice(start, end),
    blockName: 'Best Sellers',
    title: "Browse this week's best selling WordPress themes",
    subtitle: "This week's best web themes & templates have arrived.",
    cta: {
      urlSearchParams: {
        category: 'wordpress',
        date: 'this-week',
        sort: 'sales'
      },
      title: 'View more bestsellers'
    },
    evenGrid: true
  }
}
